import { useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Container } from '../../ui';
import styles from './MarketContext.module.css';

export function MarketContext() {
  const { t } = useTranslation('solutions');
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const hasAnimated = useRef(false);

  const stats = t('marketContext.stats', { returnObjects: true }) as {
    value: string; label: string;
  }[];

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Section variant="dark">
      <Container>
        <div ref={ref} className={`${styles.wrapper} ${isVisible ? styles.visible : ''}`}>
          <p className={styles.hook}>{t('marketContext.hook')}</p>
          <div className={styles.statsRow}>
            {stats.map((stat, i) => (
              <div
                key={i}
                className={styles.stat}
                style={{ '--stat-index': i } as React.CSSProperties}
              >
                <span className={styles.value}>{stat.value}</span>
                <span className={styles.label}>{stat.label}</span>
              </div>
            ))}
          </div>
          <p className={styles.source}>{t('marketContext.source')}</p>
        </div>
      </Container>
    </Section>
  );
}
